import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectRateLockTermsSchema = createSelector(
  getProgramsCategory,
  ({ rateLockTermsSchema }) => rateLockTermsSchema,
);
